/**
 * MAS Direct template logic: FIELD_DEPENDENCIES for Direct and recalculateFieldsDirect.
 * Delegates to recalcCore with Direct config (formulas + getBlendedWhlsFee).
 */

import type { RecalculateFieldsParams } from '../../shared/logic';
import { recalculateFieldsCore } from '../../recalcCore';
import { getDirectRecalcConfig } from '../../recalcConfigBuilders';

/** MAS Direct field dependencies (subset used by Direct template). */
export const FIELD_DEPENDENCIES_DIRECT: Record<string, string[]> = {
  'gsmsCostFromMfg': ['gsmsNetCostFromMfg', 'gsmsCost', 'gsmsProfit', 'suggestedBidPrice'],
  'gsmsNetCostFromMfg': ['gsmsCost', 'gsmsProfit', 'gsmsMarketingFee'],
  'mfgBottleSize': ['gsmsCost'],
  'gsmsPackSize': ['gsmsBottleCapacity', 'gsmsBottleCost', 'gsmsCapCost', 'gsmsLabelCost', 'gsmsInsertCost', 'gsmsBoxCartonCost', 'gsmsFrtCost', 'pv2Percent', 'gsmsLabor', 'gsmsCost'],
  'gsmsHndlgType': ['gsmsBottleCapacity', 'gsmsBottleCost', 'outsourceRepackFee', 'gsmsLabor', 'gsmsCost', 'gsmsMarketingFee'],
  'gsmsBottleCapacity': ['gsmsBottleCost', 'gsmsCapCost', 'gsmsLabelCost', 'gsmsInsertCost', 'gsmsBoxCartonCost', 'gsmsFrtCost', 'pv2Percent', 'gsmsLabor', 'gsmsMarketingFee'],
  'gsmsIffFee': ['gsmsCost', 'gsmsProfit'],
  'wac': ['pv2Percent'],
  'pv2Percent': ['gsmsCost'],
  'suggestedBidPrice': ['gsmsIffFee', 'gsmsCost', 'gsmsProfit', 'pv2Percent', 'wac', 'gsmsMarketingFee', 'annualTmopSavings', 'monthlyTmopSavings', 'govSavingsAnalysis', 'blendedWhlsFee', 'contractAnnualRevenue', 'contractAnnualGP', 'contractAnnualCost'],
  'gsmsProfit': ['gsmsNetCostFromMfg', 'gsmsCost'],
  'gsmsCost': ['gsmsProfit'],
  'vaTmsPercent': ['totalTmsPercent', 'targetAnnualUsage', 'blendedWhlsFee'],
  'dodTmsPercent': ['totalTmsPercent', 'targetAnnualUsage', 'blendedWhlsFee'],
  'vaAnnualUsage': ['totalTmsPercent', 'targetAnnualUsage', 'blendedWhlsFee'],
  'dodAnnualUsage': ['totalTmsPercent', 'targetAnnualUsage', 'blendedWhlsFee'],
  'tmopPercent': ['annualTmopSavings', 'monthlyTmopSavings'],
  'lowestContractPrice': ['annualTmopSavings', 'monthlyTmopSavings', 'govSavingsAnalysis'],
  'targetLaunchDate': ['blendedWhlsFee'],
};

/**
 * Recalculate fields for MAS Direct template. Uses recalcCore with Direct config.
 */
export function recalculateFieldsDirect(params: RecalculateFieldsParams): Record<string, any> {
  return recalculateFieldsCore({ ...params, productType: 'direct' }, getDirectRecalcConfig(FIELD_DEPENDENCIES_DIRECT));
}
